module.exports = __webpack_public_path__ + "img/envelope-file.91f9ac27.svg";